import { Table, Segment, Label, Header } from "semantic-ui-react";
import "./results.css";
import noImageRms from "../../images/rms.ico";
import noImageCis from '../../images/cis.ico';
import moment from 'moment';

const Results = (props) => {
  const { titles, court, docId, sysType } = props;
  const clerk = court.clerkName ? court.clerkName.toUpperCase() : "JOHN DOE";
  let fips = docId.slice(0, 3);
  let signDate = titles.find((item) => {
    return item.key === "cis_rms_doc_date";
  });

  const imgNotFound = (e) => {
    e.target.src = sysType.toLowerCase().trim() === "cis" ? noImageCis : noImageRms;
  };

  return (
    <div id="result-con">
      {/* Court Segment */}
      {court.courtName !== "" && titles.length > 0 ? (
        <Segment id="court-seg" compact textAlign="center" className="courier">
          <Label attached="top" size="small" id="court-seg-label">
            <Header id="court-name-h2" as="h2">
              {court.courtName}
            </Header>
          </Label>
          <div id="seal-statement">
            <img
              alt="court seal"
              src={`images/courtSeals/${fips}_seal_200.jpg`}
              onError={(e) => imgNotFound(e)}
            />
            <p className="courier italic">
              I, <b>{clerk}</b>, CLERK OF{" "}
              {court.courtName.toUpperCase()}, DO HEREBY CERTIFY THAT THE
              DOCUMENT WHOSE ID IS <b>{docId}</b>, WAS OFFICIALLY CERTIFIED BY
              THE {court.courtName.toUpperCase()} FILED IN THIS OFFICE ON{" "}
              {signDate.value}.
            </p>
          </div>
        </Segment>
      ) : null}

      {/* Document Result */}
      {titles.length > 0 ? (
        <Table celled striped compact size="small" id="result-table">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                Document ID: {docId}
              </Table.HeaderCell>
              <Table.HeaderCell aria-hidden="true"><span id="spacer-table-header">spacer table header</span></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {titles.map((item, idx) => {
              if(item.key === "sign_date"){
                item.value = moment(item.value, "YYYY-MM-DD").format("MM/DD/YYYY")
              }
              return (
                <Table.Row key={idx}>
                  <Table.Cell className="res-label">{item.label}</Table.Cell>
                  <Table.Cell className="res-value">{item.value}</Table.Cell>
                </Table.Row>
              );
            })}
            <Table.Row>
              <Table.Cell className="res-label">Clerk Name</Table.Cell>
              <Table.Cell className="res-value">{clerk}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      ) : null}
    </div>
  );
};

export default Results;
